import { useEffect, useRef, useState } from "react";
import { useGetAllUser } from "../../hooks/query/useGetAllUser";
import { useDebounce } from "../../hooks/useDebounce";

interface ListUserPopupProps {
    onClose: () => void;
    onCancel: () => void;
    openPopup: boolean;
    onData: (data: any[]) => void;
}

export default function ListUserPopup(props: ListUserPopupProps) {
    const { openPopup, onClose, onCancel, onData } = props;
    const [showList, setShowList] = useState(openPopup);
    const [keySearch, setKeySearch] = useState("");
    const [checkedAll, setCheckedAll] = useState(false);
    const [checkedIds, setCheckedIds] = useState<number[]>([]);
    const keyword = useDebounce(keySearch, 500);
    const listRef = useRef<HTMLDivElement | null>(null);

    const { data: listUser } = useGetAllUser();
    const users = listUser?.data || [];

    // Lọc users theo keyword
    const filteredUsers = users.filter((user: any) => {
        if (!keyword) return true;
        const searchLower = keyword.toLowerCase();
        return (
            user.fullName?.toLowerCase().includes(searchLower) ||
            user.email?.toLowerCase().includes(searchLower)
        );
    });

    const handleOverlayClick = (e: React.MouseEvent) => {
        if (e.target === e.currentTarget) {
            setShowList(false);
            setTimeout(onClose, 300);
        }
    };

    const handleSubmit = async () => {
        setShowList(false);
        setTimeout(onClose, 300);

        const selectedUsers = filteredUsers.filter((user: any) => checkedIds.includes(user.id));
        console.log("selectedUsers", selectedUsers);
        onData(selectedUsers);
    };

    useEffect(() => {
        setShowList(openPopup);
    }, [openPopup]);

    const handleCheckAll = () => {
        if (checkedAll) {
            setCheckedIds([]);
        } else {
            setCheckedIds(filteredUsers.map((u: any) => u.id));
        }
        setCheckedAll(!checkedAll);
    };

    const handleCheckOne = (id: number) => {
        if (checkedIds.includes(id)) {
            setCheckedIds(checkedIds.filter((i) => i !== id));
        } else {
            setCheckedIds([...checkedIds, id]);
        }
    };

    // Reset checkedAll khi filter thay đổi
    useEffect(() => {
        const allChecked = filteredUsers.length > 0 &&
            filteredUsers.every((user: any) => checkedIds.includes(user.id));
        setCheckedAll(allChecked);
    }, [checkedIds, filteredUsers]);

    return (
        <div
            className="fixed top-0 right-0 bottom-0 left-0 bg-[rgba(0,0,0,0.5)] z-[90] flex justify-center items-center transition-opacity duration-300"
            onClick={handleOverlayClick}
            style={{ opacity: showList ? 1 : 0 }}
        >
            <div
                className={`relative w-full lg:w-[800px] lg:min-h-[600px] h-[98%] bg-white p-[10px] rounded-box flex items-center flex-col transform transition-all duration-300 ${showList ? "translate-y-0 opacity-100" : "-translate-y-10 opacity-0"
                    }`}
            >
                <h2 className="text-secondary font-bold text-[20px] my-[20px]">
                    Danh sách User
                </h2>
                <div className="flex-1 flex flex-col my-[20px] w-[90%]">
                    <div className="relative mb-[20px] border border-[#e0e0e0] w-full h-[40px] flex rounded-[4px]">
                        <input
                            className="outline-none rounded-[4px] pl-[16px] pr-[40px] inline-block w-full"
                            placeholder="Nhập tên hoặc email user để tìm"
                            value={keySearch}
                            onChange={(e) => setKeySearch(e.target.value)}
                        />
                    </div>
                    <div className="border border-[#e0e0e0] flex-1 rounded-[4px] px-[10px] pt-[10px]">
                        <div className="flex divide-x-[2px] divide-gray-300 justify-between border-b-[2px] border-gray-200 pb-[4px]">
                            <div className="flex justify-center items-center w-1/12">
                                <input
                                    className="w-4 h-4 text-center"
                                    type="checkbox"
                                    name="user"
                                    onChange={handleCheckAll}
                                    checked={checkedAll}
                                />
                            </div>
                            <span className="w-1/12 text-center font-bold">ID</span>
                            <span className="w-5/12 text-center font-bold">Email</span>
                            <span className="w-5/12 text-center font-bold">Tên User</span>
                        </div>
                        <div
                            ref={listRef}
                            className={`${filteredUsers?.length > 9 ? "custom-scroll overflow-y-scroll" : ""
                                } max-h-[320px]`}
                        >
                            {filteredUsers?.length > 0 ? (
                                filteredUsers.map((user: any) => (
                                    <div className="flex mt-[10px]" key={user.id}>
                                        <div className="flex justify-center items-center w-1/12">
                                            <input
                                                className="w-4 h-4 text-center"
                                                type="checkbox"
                                                value={user.id}
                                                name="user"
                                                checked={checkedIds.includes(user.id)}
                                                onChange={() => handleCheckOne(user.id)}
                                            />
                                        </div>
                                        <span className="w-1/12 text-center">{user.id}</span>
                                        <span className="w-5/12 text-left pl-[10px]">{user.email}</span>
                                        <span className="w-5/12 text-left pl-[10px]">
                                            {user.fullName || "N/A"}
                                        </span>
                                    </div>
                                ))
                            ) : (
                                <div className="text-center text-gray-400 mt-[20px]">
                                    Không tìm thấy user nào
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <div className="">
                    <button
                        onClick={handleSubmit}
                        className="bg-secondary opacity-100 text-white py-[10px] px-[20px] rounded-[6px] hover:opacity-90 transition min-w-[100px] hover:scale-105"
                    >
                        Thêm
                    </button>
                    <button
                        onClick={onCancel}
                        className="border border-[#e0e0e0] ml-[20px] bg-white opacity-90 hover:opacity-100 text-[f8f9fa] px-[15px] py-[8px] rounded-[5px] min-w-[100px] hover:scale-105"
                    >
                        Hủy
                    </button>
                </div>
                <button
                    className="absolute top-[10px] right-[10px]"
                    onClick={() => {
                        setShowList(false);
                        setTimeout(onClose, 300);
                    }}
                >
                    <i className="fa-solid fa-close text-[22px] text-blue-500"></i>
                </button>
            </div>
        </div>
    );
}